module.exports = __webpack_public_path__ + "assets/img/9639ccdd6b23e5001bd9774db51f57b7.svg";